import React from "react";
import styles from "./index.module.scss";

export default function ArchiveMessageCard({
  header,
  description,
  footer,
  rating,
  ...props
}) {
  return (
    <div className={styles.archiveMessageCard}>
      <div className={styles.archiveMessageCardWrapper}>
        <div className={styles.header}>{header}</div>
        <div className={styles.rating}>{rating}</div>
        <div className={styles.description}>{description}</div>
        <div className={styles.footer}>{footer}</div>
      </div>
    </div>
  );
}
